import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { paste } from 'app/modules/wallforming/components/input-binding/utils/inputCommandUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Paste = () => {
    const { t } = useTranslation();

    const clipboardLength = usePlacementStore((state) => state.clipboard.length);

    return (
        <Menu.Item
            disabled={clipboardLength === 0}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="content_paste" />
            }
            rightSection={
                <ActionShortcutHint actionId={InputActionId.ArticlePaste} />
            }
            onClick={() => paste(usePlacementStore.getState())}
        >
            {t('paste')}
        </Menu.Item>
    );
};
